import DataExchange from './DataExchange'

export default class AdvertismentWFFMDataExchange extends DataExchange {
  /**
   * @argument {HTMLFormElement} form
   */
  constructor (form) {
    super(form)
    this.paragraph = form.parentElement.querySelector('p.text-center')
  }

  get data () {
    return this.paragraph.innerHTML
  }
}


// WEBPACK FOOTER //
// ./src/services/AdvertismentWFFMDataExchange.js